import { render } from "./BaseNavigationButton.vue?vue&type=template&id=29545207"
import script from "./BaseNavigationButton.vue?vue&type=script&lang=js"
export * from "./BaseNavigationButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__